export const imageFileTypes = [".png", ".jpg", ".jpeg", ".webp"];

export const documentFileTypes = [".pdf", ".doc", ".docx"];
